// components/Certificates.jsx
import React from 'react';
import './Hero.css'; // or your own Certificates.css

const experienceData = [
  {
    company: 'Bluestock Fintech',
    duration: 'Jan 2025 – Feb 2025',
    points: [
      'Developed the frontend of a full-stack IPO web application.',
      'Built admin dashboard and public IPO listings page.',
      'Integrated external public APIs for real-time IPO data.',
    ],
    certificate: {
      title: 'SDE Internship - Bluestock Fintech',
      file: require('../assets/bluestock.jpg'),
      type: 'image',
    },
  },
  {
    company: 'DevTown(FSWD)',
    duration: '3-Month Internship',
    points: [
      'Developed and maintained web apps using HTML, CSS, JavaScript, and SQL.',
      'Collaborated with developers to optimize performance and enhance UI.',
    ],
    certificate: {
      title: 'Full Stack Development - DevTown',
      file: require('../assets/devtown.pdf'),
      type: 'pdf',
    },
  },
  {
    company: 'ChatGPT & Al Tools(WorkShop)',
    duration: '3 Hours',
    points: [
       'Experienced various AI tools , Get to know how AI integrated in our day lifes',
    ],
    certificate: {
      title: 'ChatGPT&AI Tools - Skill Nation',
      file: require('../assets/ChatGPT & Al Tools.png'),
      type: 'image',
    },
  },
  {
    company: 'Google_Drive_Clone(BootCamp)',
    duration: '7 Days',
    points: [
       'Experienced Material CSS frameWork',
    ],
    certificate: {
      title: 'Google Drive Clone using HTML and Material CSS',
      file: require('../assets/Google_Drive_Clone.pdf'),
      type: 'pdf',
    },
  },
   {
    company: 'JavaScript & React.js(BootCamp)',
    duration: '7 Days',
    points: [
       'Experienced  javascript & React.js',
    ],
    certificate: {
      title: 'JavaScript & React.js',
      file: require('../assets/JavaScript&React.pdf'),
      type: 'pdf',
    },
  },
];

export default function Experience() {
  return (
    <section className="glass" id="certificates">
      <h2>Experience , Certificates & BootCamps</h2>

      <div className="experience-grid">
        {experienceData.map((item, index) => (
          <div className="experience-card" key={index}>
            <div className="experience-info">
              <h3>{item.company}</h3>
              <p className="experience-duration">{item.duration}</p>
              <ul>
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>

            <a
              href={item.certificate.file}
              target="_blank"
              rel="noreferrer"
              className="certificate-section"
            >
              {item.certificate.type === 'image' ? (
                <img
                  src={item.certificate.file}
                  alt={item.certificate.title}
                  className="certificate-preview"
                />
              ) : (
                <div className="pdf-icon">📄</div>
              )}
              <p className="certificate-title">{item.certificate.title}</p>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
